import React from 'react';
import { LegalPage } from '../components/LegalPage';
interface TermsPageProps {
  language: 'en' | 'es';
}
export function TermsPage({
  language
}: TermsPageProps) {
  const content = {
    en: {
      title: 'TERMS AND CONDITIONS',
      sections: [{
        heading: '1. ACCEPTANCE OF TERMS',
        paragraphs: ['By renting equipment from Blackstone Rentals LLC, you agree to these Terms and Conditions in full.']
      }, {
        heading: '2. RENTAL AGREEMENT',
        paragraphs: ['All rentals require a confirmed reservation. Rental period begins at delivery and ends at pickup. Customer is responsible for equipment during rental. Equipment must be accessible for service and pickup.']
      }, {
        heading: '3. PAYMENT TERMS',
        paragraphs: ['Payment is due prior to or at time of delivery. We accept cash, check, and electronic payment. Returned checks subject to $35 fee. Overdue accounts may be sent to collection.']
      }, {
        heading: '4. DELIVERY AND PICKUP',
        paragraphs: ['We deliver and pick up at agreed location and time. Customer must ensure clear access for our vehicle. Blocked access may result in redelivery fee. Service area: Odessa, Midland, and West Texas.']
      }, {
        heading: '5. CUSTOMER RESPONSIBILITIES',
        paragraphs: ['Use equipment for its intended purpose only. Do not move equipment without our permission. Do not place hazardous materials in units. Protect equipment from vandalism and theft. Report any damage immediately.']
      }, {
        heading: '6. DAMAGE AND LIABILITY',
        paragraphs: ["Customer is liable for damage beyond normal wear. Vandalism or theft during rental is customer's responsibility. Blackstone Rentals LLC is not liable for injuries from misuse of equipment."]
      }, {
        heading: '7. CANCELLATIONS',
        paragraphs: ['Cancellations must be made 24 hours before delivery. Same-day cancellations may have a cancellation fee. Emergency cancellations reviewed case by case.']
      }, {
        heading: '8. SERVICE AND MAINTENANCE',
        paragraphs: ['Regular service included in weekly rentals. Customer must allow access for scheduled service. Emergency service available 24/7.']
      }, {
        heading: '9. GOVERNING LAW',
        paragraphs: ['These Terms are governed by the laws of Texas. Disputes shall be resolved in Ector County, Texas.']
      }, {
        heading: '10. CONTACT',
        paragraphs: ['Blackstone Rentals LLC — Odessa, Texas', 'Phone: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com']
      }]
    },
    es: {
      title: 'TÉRMINOS Y CONDICIONES',
      sections: [{
        heading: '1. ACEPTACIÓN DE TÉRMINOS',
        paragraphs: ['Al rentar equipo de Blackstone Rentals LLC, usted acepta estos Términos en su totalidad.']
      }, {
        heading: '2. ACUERDO DE RENTA',
        paragraphs: ['Todas las rentas requieren reservación confirmada. El período comienza en la entrega y termina en la recolección. El cliente es responsable del equipo durante la renta.']
      }, {
        heading: '3. TÉRMINOS DE PAGO',
        paragraphs: ['Pago antes o en el momento de la entrega. Aceptamos efectivo, cheque y pago electrónico. Cheques devueltos tienen cargo de $35. Cuentas vencidas pueden enviarse a cobro.']
      }, {
        heading: '4. ENTREGA Y RECOLECCIÓN',
        paragraphs: ['Entregamos en el lugar y hora acordados. El cliente debe garantizar acceso libre. Acceso bloqueado puede tener cargo adicional. Área de servicio: Odessa, Midland y West Texas.']
      }, {
        heading: '5. RESPONSABILIDADES DEL CLIENTE',
        paragraphs: ['Usar el equipo solo para su propósito establecido. No mover el equipo sin nuestro permiso. No depositar materiales peligrosos. Proteger el equipo de vandalismo y robo. Reportar cualquier daño inmediatamente.']
      }, {
        heading: '6. DAÑOS Y RESPONSABILIDAD',
        paragraphs: ['El cliente es responsable de daños más allá del desgaste normal. Vandalismo o robo durante la renta es responsabilidad del cliente.']
      }, {
        heading: '7. CANCELACIONES',
        paragraphs: ['Cancelaciones con al menos 24 horas de anticipación. Cancelaciones el mismo día pueden tener cargo. Emergencias se evalúan caso por caso.']
      }, {
        heading: '8. SERVICIO Y MANTENIMIENTO',
        paragraphs: ['Servicio regular incluido en rentas semanales. El cliente debe permitir acceso para servicio. Servicio de emergencia disponible 24/7.']
      }, {
        heading: '9. LEY APLICABLE',
        paragraphs: ['Estos Términos se rigen por las leyes de Texas. Disputas se resolverán en el Condado de Ector.']
      }, {
        heading: '10. CONTACTO',
        paragraphs: ['Blackstone Rentals LLC — Odessa, Texas', 'Teléfono: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com']
      }]
    }
  };
  const t = content[language];
  return <LegalPage language={language} title={t.title} lastUpdated="January 1, 2026" sections={t.sections} data-id="element-410" />;
}